import { useModal } from "@shared/model/useModal";

export const useConferenceSettingsModal = () => useModal("conference-settings-modal");
